export const example = {
  id: {
    title: "Hub operasi di Surabaya",
    question:
      "Apakah hub Surabaya dibuka kuartal ini, atau ditahan sampai utilisasi Jakarta melewati ambang yang disepakati?",
    horizonDays: 90,
    items: [
      { id: "K1", epistemic: "KNOWN", source: "user", text: "Utilisasi Jakarta 71%" },
      { id: "K2", epistemic: "KNOWN", source: "user", text: "Kas 11 minggu" },
      { id: "A1", epistemic: "ASSUMED", source: "confirmed", text: "Permintaan Jawa Timur tumbuh 18%" },
      { id: "U1", epistemic: "UNKNOWN", source: "user", text: "Ketersediaan sewa di luar penawaran berjalan" },
    ],
    options: [
      { id: "o1", name: "Buka sekarang", reversibility: "hard" },
      { id: "o2", name: "Syarat pembuka", reversibility: "costly" },
      { id: "o3", name: "Tunda dua kuartal", reversibility: "easy" },
    ],
    brief: {
      version: 1,
      framework:
        "Pertanyaan dibatasi pada waktu pembukaan hub Surabaya dalam horizon 90 hari. Yang dinilai: posisi terhadap ambang utilisasi Jakarta dan bantalan kas. Di luar batas: pendanaan dan lokasi lain.",
      assumptions: [
        { itemId: "K1", challenge: "Utilisasi 71% belum dibandingkan dengan ambang yang disepakati." },
        { itemId: "A1", challenge: "Pertumbuhan 18% belum diuji terhadap sewa yang tersedia." },
      ],
      unknowns: [{ itemId: "U1" }],
      tradeoffs: [
        { optionId: "o1", line: "Sulit dibalik setelah hub berjalan." },
        { optionId: "o2", line: "Mahal dibalik setelah syarat dipenuhi." },
        { optionId: "o3", line: "Mudah dibalik; pertanyaan dapat dibuka kembali." },
      ],
      recommendation: {
        optionId: "o3",
        because: "Paling mudah dibalik terhadap kas 11 minggu.",
        confidence: 0.62,
      },
      whatWouldChange:
        "Utilisasi Jakarta melewati ambang yang disepakati, atau U1 terjawab. Salah satunya cukup untuk menyusun ulang brief.",
    },
    decision: {
      optionId: "o2",
      rationale: "Kas belum memberi bantalan jika ramp-up molor enam minggu.",
    },
  },
  en: {
    title: "Surabaya operations hub",
    question:
      "Is the Surabaya hub opened this quarter, or held until Jakarta utilisation passes the agreed threshold?",
    horizonDays: 90,
    items: [
      { id: "K1", epistemic: "KNOWN", source: "user", text: "Jakarta utilisation 71%" },
      { id: "K2", epistemic: "KNOWN", source: "user", text: "Cash 11 weeks" },
      { id: "A1", epistemic: "ASSUMED", source: "confirmed", text: "East Java demand grows 18%" },
      { id: "U1", epistemic: "UNKNOWN", source: "user", text: "Lease availability outside the current offer" },
    ],
    options: [
      { id: "o1", name: "Open now", reversibility: "hard" },
      { id: "o2", name: "Opening conditions", reversibility: "costly" },
      { id: "o3", name: "Defer two quarters", reversibility: "easy" },
    ],
    brief: {
      version: 1,
      framework:
        "The question is bounded to the timing of the Surabaya hub within a 90-day horizon. Assessed: position against the Jakarta utilisation threshold and the cash cushion. Outside the boundary: funding and other locations.",
      assumptions: [
        { itemId: "K1", challenge: "Utilisation of 71% has not been compared with the agreed threshold." },
        { itemId: "A1", challenge: "The 18% growth has not been tested against available leases." },
      ],
      unknowns: [{ itemId: "U1" }],
      tradeoffs: [
        { optionId: "o1", line: "Hard to reverse once the hub is running." },
        { optionId: "o2", line: "Costly to reverse once conditions are met." },
        { optionId: "o3", line: "Easy to reverse; the question can be reopened." },
      ],
      recommendation: {
        optionId: "o3",
        because: "Easiest to reverse against 11 weeks of cash.",
        confidence: 0.62,
      },
      whatWouldChange:
        "Jakarta utilisation passes the agreed threshold, or U1 is answered. Either is enough to recompose the brief.",
    },
    decision: {
      optionId: "o2",
      rationale: "Cash does not yet give a cushion if ramp-up slips six weeks.",
    },
  },
};
